import { Button } from '@shared/components/ui/button';
import { faExclamationTriangle } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

interface ErrorStateProps {
  error: Error;
  onRetry?: () => void;
}

/**
 * Componente de estado de error para Recepciones
 */
export const ErrorState: React.FC<ErrorStateProps> = ({ error, onRetry }) => {
  const { t } = useTranslation('receptionsModule');

  return (
    <div className="flex flex-col items-center justify-center h-64 gap-4 p-6">
      <div className="w-12 h-12 rounded-full bg-destructive/10 flex items-center justify-center">
        <FontAwesomeIcon icon={faExclamationTriangle} className="w-6 h-6 text-destructive" />
      </div>
      <div className="text-center">
        <h3 className="text-lg font-medium text-foreground">{t('errors.load_error')}</h3>
        <p className="text-sm text-muted-foreground mt-1">{error.message || t('errors.unexpected')}</p>
      </div>
      {onRetry && (
        <Button variant="outline" onClick={onRetry}>
          {t('button.loading')}
        </Button>
      )}
    </div>
  );
};

export default ErrorState;
